/*import {DoccliService} from '../../../providers/DoccliService.js';
const doccliService = new DoccliService();*/

export default {
  name: "Signature",
   data () {
  return {      
  loading:false

  }
},
  methods: {
    signDocument: function(){
      this.loading = true;
      var sessionSouscription = this.$globalService.getSessionSouscription();
      if(sessionSouscription == null || !sessionSouscription.doccli_id){
        this.loading = false;
        this.$dialog.error({
          text: "Une erreur s'est produite",
          title: 'Erreur',
          persistent: false,
          actions: {
            false: 'Fermer'
          }
        })
      }
      this.$router.push({name: 'ProgressSign'});
     
    }
  }
}